export const tolgeeConfig = {
    fallbackNs: false,
    defaultNs: "Global",
    defaultLanguage: "en",
    fallbackLanguage: {
        "de-RF": "de",
        "en-GB": "en",
        de: "en",
        fr: "en",
        ru: "en",
        pl: "en",
        nl: "en",
    },
    availableLanguages: ["en-GB", "en", "de-RF", "de", "fr", "ru", "pl", "nl"],
};
//# sourceMappingURL=config.js.map